import { useQuery } from '@tanstack/react-query';

import { buildProductByIdForUserQueryOptions } from '@/modules/product/queryOptions.ts';
import { useSessionId } from '@/modules/storage/useSessionId.ts';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

export function useProductById({
  productId,
  includeOffers,
  includeSellerInfo,
  retryOnMount = false,
  retry = false,
  enabled = Boolean(productId),
}: {
  productId?: string;
  includeOffers?: boolean;
  includeSellerInfo?: boolean;
  retryOnMount?: boolean;
  retry?: boolean;
  enabled?: boolean;
}) {
  const sessionId = useSessionId();

  const [, user] = useCurrentUser();

  return useQuery({
    ...buildProductByIdForUserQueryOptions({
      productId,
      userId: user?.id,
      includeOffers,
      includeSellerInfo,
      sessionId,
    }),
    enabled,
    ...(retryOnMount ? { retryOnMount } : undefined),
    ...(retry ? { retry } : undefined),
  });
}
